import { useContext } from 'react';
import { useQuery } from '@tanstack/react-query';
import { useState } from 'react';
import useGlynt from './useGlynt';
import { AppContext } from '../../App';

import { FIELDS_PAGE_SIZE } from '../../constants';

export default function usePaginatedFields(
  trainingSetId: string,
  limit: number = FIELDS_PAGE_SIZE
) {
  const { dataPoolId } = useContext(AppContext);

  const [page, setPage] = useState(0);
  const glynt = useGlynt(dataPoolId);

  const { data, isError, isPending, isFetching, refetch } = useQuery({
    queryKey: ['fields', page, trainingSetId],

    queryFn: async () =>
      (await glynt).fields.list({
        advanced: true,
        training_set: trainingSetId,
        ordering: 'field_order',
        limit,
        offset: page * FIELDS_PAGE_SIZE,
      }),

    enabled: !!dataPoolId,

    refetchOnWindowFocus: false
  });

  const total = data ? Math.ceil(data.count / FIELDS_PAGE_SIZE) : 1;

  const nextPage = () => {
    if (page < total - 1) setPage((page) => page + 1);
  };

  const previousPage = () => {
    if (page > 0) setPage((page) => page - 1);
  };

  return {
    data,
    error: isError,
    isPending,
    isLoading: isPending,
    loading: isPending,
    nextPage,
    previousPage,
    total,
    page,
    setPage,
    isFetching,
    refetch,
  };
}
